package dev.mft.website.composable.header

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.window.core.layout.WindowSizeClass
import androidx.window.core.layout.WindowWidthSizeClass

@Composable
fun Header(
    modifierMainRow: Modifier,
    windowSizeClass: WindowSizeClass
) {
    when (windowSizeClass.windowWidthSizeClass) {
        //smartphone
        WindowWidthSizeClass.COMPACT -> {
            Column(
                modifier = modifierMainRow,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                val modifierBox: Modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f)

                val config = HeaderLayoutConfig.getLayoutConfig(
                    windowSizeClass.windowWidthSizeClass,
                    windowSizeClass.windowHeightSizeClass
                )

                ImageProfile(
                    modifierBox = modifierBox,
                    imageSize = config.imageSize
                )

                Presentation(
                    modifierBox = modifierBox,
                    fontSizeTitle = config.titleSize,
                    fontSizeParagraph = config.paragraphSize,
                    padding = 20.dp
                )
            }
        }

        //tablet
        WindowWidthSizeClass.MEDIUM -> {
            Row(
                modifier = modifierMainRow,
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                val modifierBox: Modifier = Modifier
                    .fillMaxHeight()
                    .weight(1f)

                val config = HeaderLayoutConfig.getLayoutConfig(
                    windowSizeClass.windowWidthSizeClass,
                    windowSizeClass.windowHeightSizeClass
                )


                //top left corner
                Presentation(
                    modifierBox = modifierBox,
                    fontSizeTitle = config.titleSize,
                    fontSizeParagraph = config.paragraphSize,
                    padding = 40.dp
                )

                //top right corner
                ImageProfile(
                    modifierBox = modifierBox,
                    imageSize = config.imageSize
                )
            }
        }

        //pc
        WindowWidthSizeClass.EXPANDED -> {
            Row(
                modifier = modifierMainRow,
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                val modifierBox: Modifier = Modifier
                    .fillMaxHeight()
                    .weight(1f)

                val config = HeaderLayoutConfig.getLayoutConfig(
                    windowSizeClass.windowWidthSizeClass,
                    windowSizeClass.windowHeightSizeClass
                )


                //top left corner
                Presentation(
                    modifierBox = modifierBox,
                    fontSizeTitle = config.titleSize,
                    fontSizeParagraph = config.paragraphSize,
                    padding = 50.dp
                )

                //top right corner
                ImageProfile(
                    modifierBox = modifierBox,
                    imageSize = config.imageSize
                )
            }
        }
    }
}